import { render, staticRenderFns } from "./costHelp.vue?vue&type=template&id=42a5e410&"
import script from "./costHelp.vue?vue&type=script&lang=js&"
export * from "./costHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a5e410')) {
      api.createRecord('42a5e410', component.options)
    } else {
      api.reload('42a5e410', component.options)
    }
    module.hot.accept("./costHelp.vue?vue&type=template&id=42a5e410&", function () {
      api.rerender('42a5e410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJ4vR5LCpPvF/JS/costHelp.vue"
export default component.exports